import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle, FiRefreshCw, FiTarget, FiUsers, FiTrendingUp, FiBrain } = FiIcons;

const ITConsultantSection = () => {
  const skills = [
    {
      icon: FiTarget,
      title: 'Affärsförståelse',
      description: 'Förstå vad du bidrar med och vad som gör dig unik på uppdraget. Som konsult är du rådgivare och behöver förstå kundens verkliga behov.'
    },
    {
      icon: FiMessageCircle,
      title: 'Kommunikation',
      description: 'Kunna förklara tekniska koncept enkelt och tydligt. Kommunicera på svenska så alla förstår i rummet.'
    },
    {
      icon: FiRefreshCw,
      title: 'Anpassningsförmåga',
      description: 'Konsultrollen kräver flexibilitet. Förutsättningar ändras ofta och du måste kunna navigera i nya situationer.'
    },
    {
      icon: FiUsers,
      title: 'Projektledning',
      description: 'Förstå agilt arbete, Scrum och hur projekt mäts. Veta varför du är där och vad som skapar värde.'
    },
    {
      icon: FiTrendingUp,
      title: 'Nätverkande',
      description: 'Bygg ditt personliga varumärke på LinkedIn och i fysiska event. Berätta vad du är bra på och intresserad av.'
    },
    {
      icon: FiBrain,
      title: 'Livslångt Lärande',
      description: 'Var nyfiken på allt som händer i IT-branschen. Med AI utvecklas branschen snabbare än någonsin.'
    }
  ];

  return (
    <section id="it-konsult" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Vad krävs för att lyckas som{' '}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">IT-konsult?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Teknisk kompetens är bara början. Här är de viktigaste egenskaperna för att lyckas som IT-konsult
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skills.map((skill, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-br from-blue-50 to-indigo-50 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.02, y: -5 }}
            >
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={skill.icon} className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{skill.title}</h3>
              <p className="text-gray-600 leading-relaxed">{skill.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div style={{
      color: 'rgb(255, 255, 255)'
    }}
          className="mt-16 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 text-white text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-2xl font-bold mb-4">Kom ihåg: Du behöver inte vara expert!</h3>
          <p className="text-lg opacity-90 max-w-3xl mx-auto">Som konsult behöver du vara  "fem meter före alla andra". Du behöver dock inte vara fem mil framför, men du behöver kunna lite mer än andra och vara hungrig på att lära dig.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default ITConsultantSection;